import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';
import { useLanguage } from '../../contexts/LanguageContext';
import useIsMobile from '../../utils/useIsMobile';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className,
  );

  const { lang } = useLanguage();
  const isMobile = useIsMobile();
  const webWaUrl =
    lang === 'es'
      ? 'https://web.whatsapp.com/send?phone=19544708414&text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20e-comienza.'
      : 'https://web.whatsapp.com/send?phone=19544708414&text=Hello,%20I%20want%20to%20learn%20more%20about%20e-comienza.';
  const mobileWaUrl =
    lang === 'es'
      ? 'whatsapp://send?phone=19544708414&text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20e-comienza.'
      : 'whatsapp://send?phone=19544708414&text=Hello,%20I%20want%20to%20learn%20more%20about%20e-comienza.';
  const waUrl = isMobile ? mobileWaUrl : webWaUrl;
  const contactLabel = lang === 'es' ? 'Contacto' : 'Contact';
  const waLabel = lang === 'es' ? 'WhatsApp' : 'WhatsApp';

  return (
    <footer {...props} className={classes}>
      <div className="container">
        <div className={classNames('site-footer-inner', topDivider && 'has-top-divider')}>
          <div className="footer-top space-between text-xxs">
            <Logo />
            <FooterSocial />
          </div>
          <div
            className="footer-contact-row text-xxs"
            style={{
              padding: '16px 0',
              borderTop: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
              flexWrap: 'wrap',
            }}
          >
            <span
              style={{
                color: 'var(--ec-muted)',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
              }}
            >
              {contactLabel}
            </span>
            <a
              href="mailto:info@e-comienza.com"
              style={{ color: 'var(--ec-muted)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseOver={(e) => (e.target.style.color = '#24E5AF')}
              onMouseOut={(e) => (e.target.style.color = 'var(--ec-muted)')}
            >
              <span role="img" aria-label={lang === 'es' ? 'Correo' : 'Email'}>✉</span>{' '}
              info@e-comienza.com
            </a>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'var(--ec-muted)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseOver={(e) => (e.target.style.color = '#24E5AF')}
              onMouseOut={(e) => (e.target.style.color = 'var(--ec-muted)')}
            >
              <span role="img" aria-label="WhatsApp">💬</span> {waLabel}
            </a>
          </div>
          <div className="footer-bottom space-between text-xxs invert-order-desktop">
            <FooterNav />
            <div className="footer-copyright">
              © {new Date().getFullYear()} E-comienza.{' '}
              {lang === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
